export type PermissionType = 'create' | 'read' | 'update' | 'delete';
